var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"news-container"},[_c('van-skeleton',{attrs:{"title":"","row":15,"loading":_vm.loading}},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.notice.title))]),_c('p',{staticClass:"sub-title"},[_vm._v(_vm._s(_vm.notice.createDate))]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.notice.content)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }